import { GAMES_HOME_PATH } from './routes';

/**
 * Where Fias's public pages link — one list for fias.io (the fias-site arche)
 * and the Games page, so a destination moves in one place. Each page keeps its
 * own words for these links; only the addresses are shared.
 */
export const PUBLIC_SITE_LINKS = {
  home: '/',
  games: GAMES_HOME_PATH,
  /** Platform documentation lives in the Learn About Fias arche. */
  docs: '/a/arche_learn_about_fias',
  signIn: '/auth/login',
  /** The closed-beta application lives in its own arche. */
  join: '/a/arche_beta_access',
  /**
   * The legal pages. The privacy policy and terms are the ones named on
   * Google's OAuth consent screen, which requires the home page to link them.
   */
  privacy: '/legal/privacy',
  terms: '/legal/terms',
  acceptableUse: '/legal/acceptable-use',
} as const;
